import { render, staticRenderFns } from "./PedidoRetornoTable.vue?vue&type=template&id=f687579e&scoped=true"
import script from "./PedidoRetornoTable.vue?vue&type=script&lang=js"
export * from "./PedidoRetornoTable.vue?vue&type=script&lang=js"
import style0 from "./PedidoRetornoTable.vue?vue&type=style&index=0&id=f687579e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f687579e",
  null
  
)

export default component.exports